module.exports = __webpack_public_path__ + "img/1-1P61ZS013361.88d9db39.png";